export const storeProfile = {
  brandName: "مطعم البيت السعودي",
  ownerName: "عبدالله المطيري",
  description:
    "مطعم سعودي يقدّم الأكلات الشعبية الأصيلة بمكونات طازجة وأسعار مناسبة، مع خدمة سريعة وتجربة طلب سهلة من الفرع أو السيارة.",
  phone: "0112345678",
  whatsapp: "0551234567",
  email: "info@yoursaudi.com",
  commercialRegister: "1010456789",
  vatNumber: "300123456700003",
  city: "الرياض",
  address: "طريق العليا العام، حي العليا، الرياض 12611",
  cover:
    "https://readdy.ai/api/search-image?query=Wide%20panoramic%20banner%20of%20a%20warm%20elegant%20modern%20Middle%20Eastern%20restaurant%20interior%2C%20wooden%20dining%20tables%2C%20golden%20pendant%20lamps%2C%20green%20indoor%20plants%2C%20soft%20warm%20ambient%20lighting%2C%20clean%20upscale%20minimal%20aesthetic%2C%20professional%20editorial%20photography%2C%20spacious%20balanced%20composition&width=1920&height=600&seq=yc-store-cover-01&orientation=landscape&nocache=true",
  logo: "https://readdy.ai/api/search-image?query=Minimal%20flat%20logo%20mark%20of%20a%20Saudi%20restaurant%20brand%2C%20simple%20emblem%20on%20a%20clean%20light%20beige%20background%2C%20warm%20golden%20and%20green%20tones%2C%20modern%20elegant%20identity%2C%20centered%20composition&width=400&height=400&seq=yc-store-logo-01&orientation=squarish",
};

export const paymentMethods = [
  { key: "card", label: "مدى / فيزا", icon: "ri-bank-card-line", enabled: true },
  { key: "applepay", label: "Apple Pay", icon: "ri-apple-fill", enabled: true },
  { key: "wallet", label: "المحفظة الإلكترونية", icon: "ri-smartphone-line", enabled: true },
  { key: "cash", label: "الدفع النقدي", icon: "ri-money-dollar-box-line", enabled: false },
];

export const cashPolicyDisclaimer = [
  "يقر التاجر بأن دور التطبيق يقتصر على الربط التقني فقط بين أطراف العملية، دون أي تدخل في المعاملات المالية أو التنفيذية. وبناءً عليه، لا يضمن التطبيق تحصيل قيمة الطلب، ولا يضمن حضور العميل إلى المحل التجاري أو استلامه للمنتج، ولا يتحمل أي مسؤولية عن تعويض التاجر. وينحصر دور التطبيق في حال تخلف العميل عن الحضور أو السداد، في تقييد قيمة الطلب كـ“دين” على حساب العميل داخل التطبيق، ولا يحق للعميل الاستفادة من خدمات التطبيق أو الشراء مجددًا إلا بعد تسديد هذا الدين عبر المحفظة الرقمية للتطبيق لصالح التاجر.",
];

export const storeDocuments = [
  { key: "cr", label: "السجل التجاري", status: "approved" as const },
  { key: "vat", label: "شهادة ضريبة القيمة المضافة", status: "review" as const },
  {
    key: "iban",
    label: "شهادة الآيبان البنكي",
    status: "rejected" as const,
    rejectReason: "الاسم في الشهادة لا يطابق اسم صاحب الحساب المسجّل.",
  },
];